import React, { useState, useEffect } from "react";
import "./DealsSection.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDropzone } from "react-dropzone";
import { getAllDealsApi } from "../../../../requests/dealApi";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const DealsSection = ({ merchant }) => {

  const navigate = useNavigate()
  const [rows, setRows] = useState([]);
  const pendingRows = rows.filter((r) => r.approval === "pending");

  // Is header checkbox checked?
  const allChecked = rows.every((row) => row.selected);

  // Toggle all rows
  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: newValue })));
  };

  // Toggle single row
  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  const userFormik = useFormik({
    initialValues: {
      serviceType: "",
      dealName: "",
      markupPercentage: "",
      confirmPercentage: "",
    },
    validationSchema: Yup.object({
      serviceType: Yup.string().required("Please select a service type"),

      dealName: Yup.string(), // Optional

      markupPercentage: Yup.number()
        .typeError("Must be a number")
        .min(0, "Must be at least 0")
        .max(100, "Cannot exceed 100")
        .required("percentage is required"),

      confirmPercentage: Yup.number()
        .typeError("Must be a number")
        .oneOf([Yup.ref("markupPercentage")], "Must match markup percentage")
        .required("percentage is required"),
    }),
    onSubmit: (values) => {
      console.log("Form values:", values);
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/*": [],
      "application/pdf": [],
    },
    maxFiles: 5,
    onDrop: (acceptedFiles) => {
      console.log("Dropped files:", acceptedFiles);
    },
  });

  const fetchAllDealsApi = async () => {
    const data = await getAllDealsApi(merchant._id);
    if (data.status) {
      setRows(data.data);
    }
  };
  useEffect(() => {
    if (merchant) {
      fetchAllDealsApi();
    }
  }, [merchant]);

  return (
    <section className="deals-page-section">
      <div className="search-input">
        <h5 className="form-title">Deals List</h5>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              {/* <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th> */}
              <th>Deal Name</th>
              <th>Service Type</th>
              <th>Validity</th>
              <th>Discount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendingRows.length > 0 ? (
              pendingRows?.map((row, i) => (
                <tr key={i}>
                  {/* <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td> */}
                  <td>{row.dealName}</td>
                  <td>{row.serviceType}</td>
                  <td>{moment(row.end).format("YYYY-MM-DD")}</td>
                  <td>{row.discountPercentage}</td>
                  <td>{row.approval}</td>
                  <td>
                    <div
                      className="more-details"
                      onClick={() =>
                        navigate("/deals-management", { state: { deal: row } })
                      }
                    >
                      View Details{" "}
                      <img
                        src="/images/icons/detail-arrow.svg"
                        alt="detail-arrow"
                      />
                    </div>
                    {/* <span className="action-link">
                    <div
                      data-bs-toggle="modal"
                      data-bs-target="#dealsManagementModal"
                    >
                      {row.action}
                    </div>
                    {row.img}
                  </span> */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No records found for deal review
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* <div
        className="modal fade"
        id="dealsManagementModal"
        tabIndex="-1"
        aria-labelledby="dealsManagementModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content dealsManagement-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Create New Deal</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="user-info" onSubmit={userFormik.handleSubmit}>
                <div className="user-inputs">
                  <div className="row">
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="dealName"
                          value={userFormik.values.dealName}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">Deal Name</label>
                        {userFormik.touched.dealName &&
                          userFormik.errors.dealName && (
                            <div className="error">
                              {userFormik.errors.dealName}
                            </div>
                          )}
                      </div>
                    </div>

                   
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <select
                          name="vendor"
                          value={userFormik.values.vendor}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        >
                          <option value="">Choose Service Type</option>
                          <option value="eSim">eSim</option>
                          <option value="Flights">Flights</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Tours">Tours</option>
                        </select>
                        <label className="floating-label-text">
                          Applicable Vendors
                        </label>
                        {userFormik.touched.vendor &&
                          userFormik.errors.vendor && (
                            <div className="error">
                              {userFormik.errors.vendor}
                            </div>
                          )}
                      </div>
                    </div>

                    <strong className="mb-2 mt-3">Discount</strong>

                   
                    <div className="col-md-12 p-2">
                      <div className="floating-label percentage-input">
                        <input
                          type="number"
                          name="confirmPercentage"
                          placeholder="000"
                          value={userFormik.values.confirmPercentage}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <span>%</span>
                        <label className="floating-label-text">
                          Percentage
                        </label>
                        {userFormik.touched.confirmPercentage &&
                          userFormik.errors.confirmPercentage && (
                            <div className="error">
                              {userFormik.errors.confirmPercentage}
                            </div>
                          )}
                      </div>
                    </div>
                    <strong className="mb-2 mt-3">Validity & Limits</strong>
                  
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="date"
                          name="validFrom"
                          placeholder="Valid From"
                          value={userFormik.values.validFrom}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <label className="floating-label-text">
                          Valid From
                        </label>
                        {userFormik.touched.validFrom &&
                          userFormik.errors.validFrom && (
                            <div className="error">
                              {userFormik.errors.validFrom}
                            </div>
                          )}
                      </div>
                    </div>
                   
                    <div className="col-md-6 p-2">
                      <div className="floating-label">
                        <input
                          type="date"
                          name="validTo"
                          placeholder="Valid To"
                          value={userFormik.values.validTo}
                          onChange={userFormik.handleChange}
                          onBlur={userFormik.handleBlur}
                        />
                        <label className="floating-label-text">Valid To</label>
                        {userFormik.touched.validTo &&
                          userFormik.errors.validTo && (
                            <div className="error">
                              {userFormik.errors.validTo}
                            </div>
                          )}
                      </div>
                    </div>
                    <strong className="mb-2 mt-3">Media</strong>
                    <div className="col-md-12">
                      <div
                        {...getRootProps()}
                        className={`custom-dropzone ${
                          isDragActive ? "active" : ""
                        }`}
                      >
                        <input {...getInputProps()} />
                        <div className="upload-icon">
                          <img
                            src="/images/icons/upload-icon.svg"
                            alt="Upload"
                          />
                        </div>
                        <p className="upload-text">
                          Click to browse or
                          <br /> drag and drop your files
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn">
                    Create Deal
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default DealsSection;
